import i18n from './index.js'
export default {//中文
  translateText: {
    shoppingcart: "购物车",
    loginorrefisterText: "登录/注册",
    logoutText: "退出登录",
    personcenterText: "个人中心",
    placeholderText: "请选择",
    loginText: "登录",
    registerText: "注册",
    emailText: "邮箱",
    pwdText: "密码",
    forgetpwdText: "忘记密码",
    nameText: "名",
    surnameText: "姓",
    mobileText: "电话",
    setPwdText: "设置密码",
    countryText: "国家",
    company: "公司",
    birthday:"生日",
    yearText:"年",
    mouthText:"月",
    dayText:"日",
    confirmpwdText: "确认密码",
    agreeText1: "我已阅读并同意",
    agreeText2: "使用条件",
    agreeText3: "及",
    agreeText4: "隐私声明",
    agreeText5: "，并同意我的部分个人信息将根据隐私声明在境外处理。",
    emailplaceholder: '请输入邮箱',
    subscribetitleText: '订阅我们的时事通讯',
    subscribeText: '订阅',
    shareToText: '分享至',
    searchText: '搜索',
    subtractmoneyText: "最多减600",
    magnanimitycouponText: "海量优惠券等你领取",
    drawText: "立即领取",
    discountText: "超多折扣",
    purchaseText: "立即购买",
    composecouponText: "组合购买",
    manyDiscountsText: "优惠多多",
    recommendtitleText: "为你推荐",
    hotsaleproductyitleText: "热销产品",
    guessLiketitleText: "猜你喜欢",
    NoDataText: "暂无数据",
    appraiseText: "评价",
    certificate: "券",
    collectText: "收藏",
    addCartText: "加入购物车",
    enterkeywordsText: "输入关键词",
    useNowText: "立即使用",
    vouchernoText: "券编号",
    placeholderyearText:"选择年",
    placeholdermouthText:"选择月",
    placeholderdayText:"选择日",
    // 优惠券页面
    breadcrumbItemText1: '超',
    breadcrumbItemText2: '级',
    breadcrumbItemText3: '大',
    breadcrumbItemText4: '福',
    breadcrumbItemText5: '利',
    magnanimitydrawText: '海量优惠券等你领取',
    availablecouponstitleText: '可用券产品',
    drawbtnText: '领取',
    universalText: '全场通用',
    useText: '使用',
    limitText: '限',
    fullText: '满',
    subtractText: '减',
    // 折扣
    discountitemText1: '折扣不断 ,',
    discountitemText2: '钜惠连连',
    // 组合
    commoditydiscountitemText1: '组合购买 ,',
    commoditydiscountitemText2: '优惠多多',
    combinedpriceText: '组合价',
    economizeText: '节省',
    buynowText: "立即购买",
    // 产品
    ourproductsText: '我们的产品',
    productcategoryText: '产品类别',
    recommendtarText: '推荐',
    newText: '新品',
    salesvolumetarText: '销量',
    pricetarText: '价格',
    // 博客
    blogmanagementText: "热门博客",
    latestblogsText: "最新博客",
    relatedrlogsText: "相关博客",
    priceIncreasecommentText: "提交评论",
    commentsectionTtxt: "评论区",
    participatingcommentsText: "参与评论",
    // 论坛
    postingText: "发布帖子",
    topicsText: "主题",
    replyText: "回复",
    viewText: "查看",
    lastreplyText: "最后回复",
    publishText: "发布",
    placeholdertypeText: "请选择主题分类",
    placeholdertitleText: "请输入标题",
    placeholdercontentsText: "请输入内容",
    fromtopicText: "来自主题：",
    firstfloor: "1楼",
    floorText: "楼",
    fromText: "来自",
    postreplyText: "发表回复",
    // 个人中心 - 我的订单
    myorderText: "我的订单",
    mycommentsText: "我的评论",
    mycollectionText: "我的收藏",
    couponText: "优惠券",
    shippingaddressText: "收货地址",
    myPostText: "我的贴子",
    personalinformationText: "个人信息",
    editText: "编辑",
    allordersText: "全部订单",
    unpaidText: "待支付",
    shippedText: "待发货",
    receivedText: "待收货",
    evaluatedText: "待评价",
    baidText: "待付款",
    completedText: "已完成",
    productinfText: "产品信息",
    unitpricethText: "单价",
    quantitythText: "数量",
    actualpaymentthText: "实付款",
    transactionstatusthText: "交易状态",
    operationthText: "操作",
    ordernumberText: "订单号",
    orderdetailsText: "订单详情",
    cancelorderText: "取消订单",
    confirmText: "确 定",
    cancelText: "取 消",
    deleteordertitle: "确定删除当前订单？",
    successfultradeText: "交易成功",
    paymentText: "付款",
    confirmreceiptText: "确认收货",
    nncommentText: '暂无评论',
    // 个人中心 - 我的评论
    productText: "产品",
    productdetailText: "评价详情",
    replyblogText: "回复博客：",
    //个人中心 - 收货地址
    addseliveryaddressText: "新增收货地址",
    addaddresstitleText1: "已保存",
    addaddresstitleText2: "条地址，还能保存",
    addaddresstitleText3: "条地址",
    defaultText: "默认",
    consigneeText: "收货人：",
    addressText: "所在地址：",
    fulladdressText: "详细地址：",
    setdefaultText: "设为默认",
    mobilephoneText: "手机：",
    viewmoreText: "查看更多",
    replypostText: "回复帖子：",
    // 个人中心 - 个人信息
    nameLabel:"姓名",
    sexlabel:"性别",
    modifyavatarText:"修改头像",
    sexmanText:"男",
    sexwomanText:"女",
    secrecyText:"保密",
    replaceText:"更换",
    saveText:"保存",
    oldpasswordText:"原密码",
    newpasswordText:"新密码",
    confirmpasswordText:"确认密码",
    opdpleasolderText:"请输入原密码",
    newpleasolderText:"请输入新密码",
    unboundText:"未绑定",
    bindingText:"绑定",
    unbindingText:"解绑",
    // 个人中心-个人信息
    regionText:"所在地区",
    addconsigneleasolderText:"请填写收货人姓名",
    countrypleasolderText:"请选择国家",
    provinceleasolderText:"请选择省",
    citypleasolderText:"请选择市",
    areapleasolderText:"请选择区",
    fulladdressTextpleasolderText:"请输入详细地址",
    addconsignephoneleasolderText:"请填写收货人手机号码",
    emailpleasolderText:"请输入邮箱地址",
    phoneText:'手机号码',
    uploadimgText:"上传图片",
    updateuserface:"修改头像",
    uploadimgtitle1:"支持jpg、jpeg、png 格式的图片",
    uploadimgtitle2:"推荐尺寸：200*200或等比例图片",
    updateemailText:"修改邮箱",
    updatemobileText:"修改手机号码",
    dialogemailtitle:"邮箱地址",
    dialogmobiletitle:"手机号码",
    dialogheadertitle:" 输入与您的 锦格 账户相关联",
    continueText:"继续",
    verificationinformation:"验证信息",
    verificationinformationTitle1:"要继续，请完成此验证步骤。 我们已向",
    verificationinformationTitle2:"发送了验证码。 请在下面输入。",
    verificationcode:"验证码",
    newtitle:"新",
    dialognewmobiletitle:"输入要关联的新的手机号。并点击确认更换",
    confirmpbtnText:"确认",
    titlecpuntryselect:"选择国家",
    hotcountrytitle:"热门国家",
    aboutusText:"关于我们",
    // 订单详情
    havequestionsText:"有疑问",
    preferentialText:"优惠",
    enquiryText:"询价",
    combinationdiscountText:"组合优惠",
    introduceText:"介绍",
    buyermycommentsText:"买家评论",
    starText:"星",
    yourmailboxText:"你的邮箱",
    placeholderquestionText:"请写下你的问题",
    uploadimglimtText:"请上传JPG/GIF/PNG文件。图片大小不能超过2MB。",
    submitbtnText:"提交",
    // 购物车
    selectText:"选择",
    tipscartsText:"已选产品(不含运费)",
    settlementText:"结算",
    selectallText:"全选",
    amountText:"金额",
    addtofavoritesText:"加入收藏夹",
    havecollectedText:"取消收藏",
    tipdelecteproduct:"确定删除当前商品？",
    deleteText:"删除",
    tipclearcart:"确定清空购物车？",
    clearcartText:"清空购物车",
    totalText:"合计",
    totaltipText:"件商品(不含运费):",

    // 后续补充的文本
    pieceText:"件",
    freightText:"运费：",
    taxationText:"税费：",
    fullreductionamountText:"满减金额：",
    amountpayableText:"应付金额：",
    confirmorderText:"确认订单",
    paymentsucceededText:"支付成功",
    receivinginformationText:"收货信息",
    othershippingaddressText:"其它收货地址",
    addshippingaddressText:"添加收货地址",
    selectshippingaddressText:"选择收货地址",
    selfprimingText:"自提点",
    typeofshippingText:"运输方式",
    inquirecostsText:"点击此处咨询运费",
    confirmproductinformationText:"确认产品信息",
    settlementinformationText:"结算信息",
    clipcoupons:"使用优惠券",
    allitemsText:"全部商品",
    validtoText:"有效期至",
    pieceproductTotal:"件产品 总计：",
    placeorder:"提交订单",
    consultText:"咨询",
    consultationText:"请输入咨询内容",
    sendoutText:"发 送",
    enterproductname:"输入产品名称",
    contentText:"内容",
    filerestrictionsText:"请上传JPG/GIF/PNG文件。图片大小不能超过2MB。",
    withaccountText:"输入与您的 锦格 账户相关联的电子邮箱地址",
    pagelostText:"很抱歉，你所访问的页面已失联",
    pagelostText1:"秒后自动跳转到上一页，如没跳转 请点击刷新按钮",
    pagelostText2:"刷新",
    pagelostText3:"返回首页",
    verificationrequiredText:"需要验证",
    continuestepemailText:"要继续，请完成此验证步骤。 我们已向 电子邮件",
    sendcodeText:"发送了验证码。 请在下面输入。",
    resendverificationcodeText:"重新发送验证码",
    createnewpasswordText:"创建新密码",
    providepasswordText:"您在每次登录时，都需要提供此密码。",
    savechangeText:"保存更改并登录",
    shareToText1: 'follow us  on',
    productDetailsText:"产品细节",
    signedforText:"已签收",
    rejectionText:"拒收",
    evaluated1Text:"已评价",
    reviewedText:"待审核",
    PaidText:"已付款",
    subtotalText:"小计",
    waitingforpaymentText:"等待付款",
    automaticclosingText:"来付款，超时订单自动关闭",
    patientText:"尊敬的客户，您的订单正在出库，请您耐心等待。",
    consigneeinformationText:"收货人信息",
    paymentinformationText:"付款信息",
    paymentmethodText:"付款方式：",
    paymenttimeText:"付款时间：",
    fullnameText:"全名",

  }
}


// WEBPACK FOOTER //
// ./src/assets/language/local_zn.js